export default __webpack_public_path__ + "static/governance-group-ca332c8275c35e530dcdaee83b90dc0e.png";